import { getFullUrl } from "../../../../utils/helper";
import { ToolItemProps } from "../../types";

const ToolItem = ({ url, title }: ToolItemProps) => {
  return (
    <div
      className="card flex flex-col  justify-center items-center gap-[8px] w-[213px] min-h-[150px] p-[12px] max-md:py-[12px] max-md:px-[6px] max-md:gap-[4px] max-md:w-[31%] max-md:min-h-[76px]"
    >
      <img
        src={getFullUrl(url)}
        alt={title}
        width={40}
        height={40}
        loading="lazy"
        decoding="async"
        className="h-[40px] w-[40px] object-contain max-md:h-[24px] max-md:w-[24px]"
      />
      
      <div className={`text-[16px] font-normal text-black line-clamp-2 leading-[24px] max-md:text-[12px] max-md:leading-[16px] break-all `}>{title}</div>
    </div>
  );
};

export default ToolItem;